import script from "./ScrollUpButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollUpButton.vue?vue&type=script&setup=true&lang=js"

import "./ScrollUpButton.vue?vue&type=style&index=0&id=9e54e2b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e54e2b8"]])

export default __exports__